<template>
  <div class="reviewHDDT">
    <div class="header header-before">
      <div class="logo">
        <a href="#"><img src="@/pages/contract/review/img/Nextpay-logo-white.svg" /></a>
        <h1>Xác nhận thông tin hợp đồng</h1>
      </div>
    </div>
    <!-- Main -->
    <div class="main">
      <div class="title-main">
        <ul class="nav nav-tabs" role="tablist">
          <li v-if="!keyTab" class="nav-item" role="presentation">
            <button type="button" @click="keyTab = true" class="nav-link">
              <span><img src="@/pages/contract/review/img/tomtat.svg" /></span>
              Xem tóm tắt
            </button>
          </li>
          <li v-if="keyTab" class="nav-item" role="presentation">
            <button type="button" @click="keyTab = false" class="nav-link">
              <span><img src="@/pages/contract/review/img/xemhd.svg" /></span>
              Xem hợp đồng
            </button>
          </li>
          <li class="nav-item" v-if="canBack">
            <button
              type="button"
              @click="$router.back()"
              class="nav-link text-danger ml-2"
              style="color: red !important"
            >
              Quay lại
            </button>
          </li>
        </ul>
        <div v-if="showAction" class="list-btn">
          <button
            v-if="!dataContract.isMerchantAgree && dataContract.state === 'SENT'"
            type="button"
            class="btn btn-primary btn-sm"
            @click="$emit('confirm', true)"
          >
            Xác nhận
          </button>
          <button
            v-if="!dataContract.isMerchantAgree && dataContract.state === 'SENT'"
            type="button"
            class="btn btn-outline-danger btn-sm"
            @click="$emit('confirm', false)"
          >
            Từ chối
          </button>
          <div
            v-if="dataContract.isMerchantAgree === true && dataContract.state === 'WAITING_SIGN'"
            class="btn btn-outline-success btn-sm"
            disabled=""
          >
            <i class="bx bxs-check-circle"></i> Đã xác nhận
          </div>
          <div
            v-if="dataContract.isMerchantAgree === false && dataContract.state === 'REJECTED_MC'"
            class="btn btn-outline-danger btn-sm"
            disabled=""
          >
            <i class="bx bxs-minus-circle"></i> Đã từ chối
          </div>
        </div>
      </div>
      <div class="main-content">
        <div class="tab-content">
          <div v-if="keyTab">
            <contractSummary :dataContract="dataContract"></contractSummary>
            <appendixCredits :dataContract="dataContract"></appendixCredits>
            <appendixTrans :dataContract="dataContract"></appendixTrans>
            <appendixDevice :dataContract="dataContract"></appendixDevice>
            <appendixPackage :dataContract="dataContract"></appendixPackage>
            <appendixVisa :dataContract="dataContract"></appendixVisa>
            <appendixHomePayLater :dataContract="dataContract"></appendixHomePayLater>
            <appendixQrConnector :dataContract="dataContract"></appendixQrConnector>
            <appendixLinkCard :dataContract="dataContract"></appendixLinkCard>
            <!-- <appendixLend :dataContract="dataContract"></appendixLend> -->
            <appendixChangeInfo :dataContract="dataContract"></appendixChangeInfo>
            <contractSummary2 :dataContract="dataContract"></contractSummary2>
            <modalBieuphiTragop></modalBieuphiTragop>
          </div>
          <div v-if="!keyTab">
            <div
              v-if="
                dataContract.typeCustomer === 'COMPANY' &&
                businessStateView.includes(dataContract.state) &&
                srcPDF
              "
              class="tab-content"
            >
              <pdfViewer :url="srcPDF" />
            </div>
            <div v-else>
              <ul class="nav nav-tabs tab-child-list" role="tablist">
                <li
                  class="nav-item"
                  v-if="
                    (!dataContract.isNganluongContract ||
                      (dataContract.isTransferNganluong && dataContract.isNganluongContract)) &&
                    !isOnboardQr(dataContract.lstAppendixDevices)
                  "
                >
                  <a :class="`${getActive(1)} nav-link`" @click="keyChild = 1"> Hợp đồng (Vimo)</a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    dataContract.isNganluongContract &&
                    !hasAppendixNL(dataContract.lstAppendixNganluongConverts) &&
                    !isOnboardQr(dataContract.lstAppendixDevices)
                  "
                >
                  <a :class="`${getActive(16)} nav-link`" @click="keyChild = 16">
                    Hợp đồng (Ngân lượng)
                  </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    hasAppendixNL(dataContract.lstAppendixNganluongConverts) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(17)} nav-link`" @click="keyChild = 17">
                    Hợp đồng (Ngân lượng)
                  </a>
                </li>

                <li
                  class="nav-item"
                  v-if="
                    hasAppendix(dataContract.lstAppendixTrans) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(2)} nav-link`" @click="keyChild = 2"> Phụ lục trả phí </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    hasAppendix(dataContract.lstAppendixCredits) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(3)} nav-link`" @click="keyChild = 3"> Phụ lục trả góp </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    isDevice(dataContract.lstAppendixDevices) ||
                    isOnboardQr(dataContract.lstAppendixDevices)
                  "
                >
                  <a :class="`${getActive(4)} nav-link`" @click="keyChild = 4">
                    {{
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                        ? 'Hợp đồng cung cấp loa'
                        : 'Phụ lục thiết bị'
                    }}
                  </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    hasAppendix(dataContract.lstAppendixPackages) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(5)} nav-link`" @click="keyChild = 5">
                    Phụ lục phần mềm
                  </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    isCashback(dataContract.lstAppendixDevices) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(6)} nav-link`" @click="keyChild = 6">
                    Phụ lục Cashback
                  </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    hasAppendix(dataContract.lstAppendixVisas) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(7)} nav-link`" @click="keyChild = 7"> Phụ lục Visa </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    isLend(dataContract.lstAppendixDevices) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(8)} nav-link`" @click="keyChild = 8">
                    Phụ lục cho mượn
                  </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    hasAppendix(dataContract.lstAppendixOnUss) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(9)} nav-link`" @click="keyChild = 9"> Phụ lục ON-US </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    hasAppendix(dataContract.lstAppendixChange) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(10)} nav-link`" @click="keyChild = 10">
                    Phụ lục Thay đổi thông tin
                  </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    isRent(dataContract.lstAppendixDevices) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(11)} nav-link`" @click="keyChild = 11">
                    Phụ lục thuê thiết bị
                  </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    hasAppendix(dataContract.lstAppendixHPLs) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(12)} nav-link`" @click="keyChild = 12">
                    Phụ lục Home Pay Later
                  </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    hasAppendix(dataContract.lstAppendixQrConnectors) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(15)} nav-link`" @click="keyChild = 15">
                    Phụ lục QR Connector
                  </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    hasAppendix(dataContract.lstAppendixLinkCards) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(13)} nav-link`" @click="keyChild = 13">
                    Phụ lục Link Card
                  </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    hasAppendix(dataContract.lstAppendixQrPayFee) &&
                    !(
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    )
                  "
                >
                  <a :class="`${getActive(14)} nav-link`" @click="keyChild = 14">
                    Phụ lục phí QRPay
                  </a>
                </li>
                <!--
                  * NOTE: Luôn để contract bảo vệ thông tin này xuống cuối cùng.
                -->
                <li class="nav-item">
                  <a :class="`${getActive(1000)} nav-link`" @click="keyChild = 1000">
                    Phụ lục bảo vệ dữ liệu cá nhân
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <div v-if="keyChild === 1" :class="getActive(1)">
                  <contractReviewQr
                    :dataContract="dataContract"
                    :tableContactInfos="tableContactInfos"
                    v-if="isDeviceExsistQr(dataContract.lstAppendixDevices)"
                  ></contractReviewQr>
                  <contractReview
                    :dataContract="dataContract"
                    :tableContactInfos="tableContactInfos"
                    v-else
                  >
                  </contractReview>
                </div>
                <div v-if="keyChild === 16" :class="getActive(16)">
                  <contractReviewQrNl
                    :dataContract="dataContract"
                    :tableContactInfos="tableContactInfos"
                    v-if="isDeviceExsistQr(dataContract.lstAppendixDevices)"
                  ></contractReviewQrNl>
                  <contractReviewNl
                    :dataContract="dataContract"
                    :tableContactInfos="tableContactInfos"
                    v-else
                  >
                  </contractReviewNl>
                </div>
                <div v-if="keyChild === 17" :class="getActive(17)">
                  <!-- 1. HỢP ĐỒNG THANH LÝ VIMO -->
                  <contractLiquidVimo
                    v-if="!isCompany"
                    :dataContract="dataContract"
                    :appendix="
                      dataContract.lstAppendixNganluongConverts
                        ? dataContract.lstAppendixNganluongConverts.find(
                            e => e.isCreatedWithContract
                          ) || dataContract.lstAppendixNganluongConverts[0]
                        : null
                    "
                  />

                  <!-- 5. YÊU CẦU HỖ TRỢ CHUYỂN GIAO DỮ LIỆU -->

                  <contractTransferDataNl
                    v-if="!isCompany"
                    :dataContract="dataContract"
                    :appendix="
                      dataContract.lstAppendixNganluongConverts
                        ? dataContract.lstAppendixNganluongConverts.find(
                            e => e.isCreatedWithContract
                          ) || dataContract.lstAppendixNganluongConverts[0]
                        : null
                    "
                  />
                  <!-- 2. HỢP ĐỒNG HỢP TÁC CHẤP NHẬN THANH TOÁN -->
                  <!-- <contractReviewQrNl
                    :dataContract="dataContract"
                    :tableContactInfos="tableContactInfos"
                    :isHiddenFilePdf="true"
                    v-if="isDeviceExsistQrNl(dataContract.lstAppendixNganluongConverts)"
                  /> -->
                  <contractReviewNl
                    :dataContract="dataContract"
                    :tableContactInfos="tableContactInfos"
                    :isHiddenFilePdf="true"
                    :dataAppendix="
                      dataContract && dataContract.lstAppendixNganluongConverts
                        ? dataContract.lstAppendixNganluongConverts.find(
                            e => e.isCreatedWithContract
                          )
                        : null
                    "
                  />
                  <!-- 3. PHỤ LỤC BIỂU PHÍ VÀ NGUYÊN TẮC CHẤP NHẬN THANH TOÁN -->
                  <!-- <contractTransQrNl
                    :dataContract="dataContract"
                    :appendix="
                      dataContract && dataContract.lstAppendixTrans
                        ? dataContract.lstAppendixTrans.find(e => e.isCreatedWithContract)
                        : null
                    "
                    v-if="isDeviceExsistQrNl(dataContract.lstAppendixNganluongConverts)"
                  /> -->
                  <contractTransNl
                    :dataContract="dataContract"
                    :appendix="
                      dataContract && dataContract.lstAppendixNganluongConverts
                        ? dataContract.lstAppendixNganluongConverts.find(
                            e => e.isCreatedWithContract
                          )
                        : null
                    "
                  />
                  <!-- 4. PHỤ LỤC BẢO VỆ DỮ LIỆU CÁ NHÂN -->
                  <contractProtectPersonalNl
                    :dataContract="dataContract"
                    :appendix="
                      dataContract.lstAppendixNganluongConverts
                        ? dataContract.lstAppendixNganluongConverts.find(
                            e => e.isCreatedWithContract
                          ) || dataContract.lstAppendixNganluongConverts[0]
                        : null
                    "
                  />

                  <!-- 6. BIÊN BẢN THỎA THUẬN KIỂM TRA THIẾT BỊ -->
                  <contractDeviceCheckNl
                    :dataContract="dataContract"
                    :appendix="
                      dataContract.lstAppendixNganluongConverts
                        ? dataContract.lstAppendixNganluongConverts.find(
                            e => e.isCreatedWithContract
                          ) || dataContract.lstAppendixNganluongConverts[0]
                        : null
                    "
                  />
                </div>
                <div v-if="keyChild === 2" :class="getActive(2)">
                  <contractTransQr
                    :dataContract="dataContract"
                    v-if="isDeviceExsistQr(dataContract.lstAppendixDevices)"
                  ></contractTransQr>
                  <contractTrans :dataContract="dataContract" v-else></contractTrans>
                </div>
                <div v-if="keyChild === 3" :class="getActive(3)">
                  <contractCredits :dataContract="dataContract"></contractCredits>
                </div>
                <div
                  :class="getActive(4)"
                  v-if="
                    keyChild === 4 &&
                    (isDevice(dataContract.lstAppendixDevices) ||
                      isOnboardQr(dataContract.lstAppendixDevices))
                  "
                >
                  <contractDeviceOnboardQr
                    v-if="
                      isOnboardQr(dataContract.lstAppendixDevices) &&
                      !dataContract.isNganluongContract
                    "
                    :dataContract="dataContract"
                  >
                  </contractDeviceOnboardQr>
                  <contractTapToPhone
                    v-else-if="isTapToPhone(dataContract.lstAppendixDevices)"
                    :dataContract="dataContract"
                  >
                  </contractTapToPhone>
                  <contractDevice v-else :dataContract="dataContract"></contractDevice>
                </div>
                <div :class="getActive(5)" v-if="keyChild === 5">
                  <contractPackage :dataContract="dataContract"></contractPackage>
                </div>
                <div :class="getActive(6)" v-if="keyChild === 6">
                  <contractCashback :dataContract="dataContract"></contractCashback>
                </div>
                <div :class="getActive(7)" v-if="keyChild === 7">
                  <contractVisa :dataContract="dataContract"></contractVisa>
                </div>
                <div :class="getActive(8)" v-if="keyChild === 8">
                  <contractLend :dataContract="dataContract"></contractLend>
                </div>
                <div :class="getActive(9)" v-if="keyChild === 9">
                  <contractOnUs :dataContract="dataContract"></contractOnUs>
                </div>
                <div :class="getActive(10)" v-if="keyChild === 10">
                  <contractChange
                    :dataContract="dataContract"
                    :config="configInfoChange"
                  ></contractChange>
                </div>
                <div :class="getActive(11)" v-if="keyChild === 11">
                  <contractRents :dataContract="dataContract"></contractRents>
                </div>
                <div :class="getActive(12)" v-if="keyChild === 12">
                  <contractHomePayLater :dataContract="dataContract"></contractHomePayLater>
                </div>
                <div :class="getActive(15)" v-if="keyChild === 15">
                  <contractQrConnetor :dataContract="dataContract"></contractQrConnetor>
                </div>
                <div :class="getActive(13)" v-if="keyChild === 13">
                  <contractLinkCard :dataContract="dataContract"></contractLinkCard>
                </div>
                <div v-if="keyChild === 14" :class="getActive(14)">
                  <ContractTransQrpay :dataContract="dataContract"></ContractTransQrpay>
                </div>
                <!--
                  * NOTE: Luôn để contract bảo vệ thông tin này xuống cuối cùng.
                -->
                <div :class="getActive(1000)" v-if="keyChild === 1000">
                  <contractProtectPersonal :dataContract="dataContract"></contractProtectPersonal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="mb-4" v-if="keyTab">
      <div class="footer-title">
        <p>
          <a href=""><img src="@/pages/contract/review/img/nextpay-logo.svg" alt="" /></a>
          Hỗ trợ thanh toán
        </p>
        <p>CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</p>
      </div>
      <ul class="footer-logo">
        <li>
          <a
            href="https://cdn.webrazzi.com/uploads/2013/12/redherring-global-winner.png"
            target="_blank"
            ><img src="@/pages/contract/review/img/global.png" alt=""
          /></a>
        </li>
        <li>
          <a
            href="https://www.sbv.gov.vn/webcenter/portal/vi/menu/trangchu/ttsk/ttsk_chitiet;jsessionid=Pkrwf92VGC5GdKySnvLJWgK5Hg5T6rv6BQK9G5lr8ZyK0DthZvwF!298591869!1655082551?centerWidth=80%25&amp;dDocName=SBVWEBAPP01SBV079234&amp;leftWidth=20%25&amp;rightWidth=0%25&amp;showFooter=false&amp;showHeader=false&amp;_adf.ctrl-state=9sau1ipwg_115&amp;_afrLoop=3971849221001628#%40%3F_afrLoop%3D3971849221001628%26centerWidth%3D80%2525%26dDocName%3DSBVWEBAPP01SBV079234%26leftWidth%3D20%2525%26rightWidth%3D0%2525%26showFooter%3Dfalse%26showHeader%3Dfalse%26_adf.ctrl-state%3Dyj4aegj4q_4"
            target="_blank"
            ><img src="@/pages/contract/review/img/icon-hh.png" alt=""
          /></a>
        </li>
      </ul>
    </footer>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import appendixCredits from '@/components/contracts/appendix-component/appendix-credits.vue'
  import appendixTrans from '@/components/contracts/appendix-component/appendix-trans.vue'
  import appendixDevice from '@/components/contracts/appendix-component/appendix-devices.vue'
  import appendixPackage from '@/components/contracts/appendix-component/appendix-package.vue'
  import appendixVisa from '@/components/contracts/appendix-component/appendix-visa.vue'
  import appendixHomePayLater from '@/components/contracts/appendix-component/appendix-home-pay-later.vue'
  import appendixQrConnector from '@/components/contracts/appendix-component/appendix-qr-connector.vue'
  import appendixLinkCard from '@/components/contracts/appendix-component/appendix-link-card.vue'
  // import appendixLend from "@/components/contracts/appendix-component/appendix-lend.vue";
  import appendixChangeInfo from '@/components/contracts/appendix-component/appendix-info.vue'

  import contractReview from '@/components/contracts/appendix/contract-review.vue'
  import contractReviewQr from '@/components/contracts/appendix/contract-review-qr.vue'
  import contractTrans from '@/components/contracts/appendix/contract-trans.vue'
  import contractTransQr from '@/components/contracts/appendix/contract-trans-qr.vue'
  import contractCredits from '@/components/contracts/appendix/contract-credits.vue'
  import contractDevice from '@/components/contracts/appendix/contract-device.vue'
  import contractDeviceOnboardQr from '@/components/contracts/appendix/contract-device-onboard-qr.vue'
  import contractTapToPhone from '@/components/contracts/appendix/contract-tap-to-phone.vue'
  import contractVisa from '@/components/contracts/appendix/contract-visa.vue'
  import contractCashback from '@/components/contracts/appendix/contract-cashback.vue'
  import contractPackage from '@/components/contracts/appendix/contract-package-v2/index.vue'
  import contractSummary from '@/components/contracts/others-component/contract-summary.vue'
  import contractSummary2 from '@/components/contracts/others-component/contract-summary2.vue'
  import contractLend from '@/components/contracts/appendix/contract-lend.vue'
  import contractOnUs from '@/components/contracts/appendix/contract-on-us.vue'
  import contractChange from '@/components/contracts/appendix/contract-change.vue'
  import modalBieuphiTragop from '@/components/contracts/others-component/modal-bieuphi-tragop.vue'
  import contractRents from '../../../../components/contracts/appendix/contract-rents.vue'
  import contractHomePayLater from '@/components/contracts/appendix/contract-home-pay-later.vue'
  import contractQrConnetor from '@/components/contracts/appendix/contract-qr-connetor.vue'
  import contractLinkCard from '@/components/contracts/appendix/contract-linkcard.vue'

  import contractProtectPersonal from '@/components/contracts/appendix/contract-protect-personal.vue'
  import pdfViewer from '@/pages/contract/review/PDFViewer'
  import { CommonService } from '@/services/common.service'
  import ContractTransQrpay from '@/components/contracts/appendix/contract-trans-qrpay.vue'

  import contractReviewNl from '@/components/contracts/appendix/contract-review-nl.vue'
  import contractReviewQrNl from '@/components/contracts/appendix/contract-review-qr-nl.vue'
  import contractLiquidVimo from '@/components/contracts/appendix/contract-liquid-vimo.vue'
  import contractTransNl from '@/components/contracts/appendix/contract-trans-nl.vue'
  // import contractTransQrNl from '@/components/contracts/appendix/contract-trans-qr-nl.vue'
  import contractProtectPersonalNl from '@/components/contracts/appendix/contract-protect-personal-nl.vue'
  import contractTransferDataNl from '@/components/contracts/appendix/contract-transfer-data-nl.vue'
  import contractDeviceCheckNl from '@/components/contracts/appendix/contract-device-check-nl.vue'

  export default {
    props: {
      dataContract: {
        type: Object,
      },
      srcPDF: {
        type: String,
        default: null,
      },
      canBack: {
        type: Boolean,
        default: false,
      },
      showAction: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        keyBrand: 'VIMO',
        keyChild: 1,
        keyTab: true,
        businessStateView: Config.businessStateView,
        tableContactInfos: [],
        configInfoChange: {},
      }
    },
    watch: {
      dataContract: {
        immediate: true,
        handler(val) {
          if (val) {
            this.keyBrand = val.isNganluongContract ? 'NGANLUONG' : 'VIMO'

            if (
              this.isOnboardQr &&
              this.isOnboardQr(val.lstAppendixDevices) &&
              !val.isNganluongContract
            ) {
              this.keyChild = 4
            } else if (val.lstAppendixNganluongConverts?.some(s => s.isCreatedWithContract)) {
              this.keyChild = 17
            } else if (val.isNganluongContract) {
              this.keyChild = 16
            } else {
              this.keyChild = 1
            }
          }
        },
      },
    },

    components: {
      appendixCredits,
      appendixTrans,
      contractCashback,
      appendixDevice,
      appendixPackage,
      appendixVisa,
      appendixHomePayLater,
      appendixQrConnector,
      appendixLinkCard,
      // appendixLend,
      appendixChangeInfo,
      contractReview,
      contractReviewQr,
      contractTrans,
      contractTransQr,
      contractCredits,
      contractDevice,
      contractDeviceOnboardQr,
      contractTapToPhone,
      contractVisa,
      contractPackage,
      contractSummary,
      contractSummary2,
      contractLend,
      contractHomePayLater,
      contractQrConnetor,
      contractLinkCard,
      contractOnUs,
      contractChange,
      modalBieuphiTragop,
      pdfViewer,
      contractProtectPersonal,
      contractRents,
      ContractTransQrpay,
      contractReviewNl,
      contractReviewQrNl,
      contractLiquidVimo,
      contractTransNl,
      // contractTransQrNl,
      contractProtectPersonalNl,
      contractTransferDataNl,
      contractDeviceCheckNl,
    },
    created() {
      this.getConfigSystem()
      this.getConfigInfoChange()
    },
    methods: {
      getActive(value) {
        if (this.keyChild === value) return 'active'
      },
      isCompany() {
        return (
          this.dataContract?.typeCustomer === 'COMPANY' ||
          this.dataContract?.customerInfoCommon?.customerType === 'COMPANY'
        )
      },
      hasAppendixNL(arr) {
        return arr?.find(s => s.signForm === 'E_CONTRACT ')
      },
      hasAppendix(arr) {
        return arr?.find(s => s.isCreatedWithContract)
      },
      isDevice(arr) {
        const appendix = arr.find(
          s =>
            s.appendixDevice &&
            s.appendixDevice.isCashback !== true &&
            s.appendixDevice.isLend !== true &&
            s.appendixDevice.isRent !== true &&
            s.isCreatedWithContract
        )
        if (appendix) {
          const map =
            appendix.appendixDevice && appendix.appendixDevice.deviceInfos
              ? appendix.appendixDevice.deviceInfos.reduce((arr, current) => {
                  arr.push(current.name)

                  return arr
                }, [])
              : []

          if (map.length > 0) {
            if (map.includes('ONBOARD_QR') && map.length == 1) {
              return false
            }

            if (map.includes('ONBOARD_QR') && map.length > 1) {
              let flag = false
              map.map(item => {
                if (item != 'ONBOARD_QR') {
                  flag = true
                }
              })

              return flag
            }
          }
        }

        if (!appendix) {
          return false
        }

        return true
      },
      isDeviceNl(arr) {
        const appendix = arr.find(
          s =>
            s.appendixNganluongConvert &&
            s.appendixNganluongConvert.isCashback !== true &&
            s.appendixNganluongConvert.isLend !== true &&
            s.appendixNganluongConvert.isRent !== true &&
            s.isCreatedWithContract
        )
        if (appendix) {
          const map =
            appendix.appendixNganluongConvert && appendix.appendixNganluongConvert.deviceInfos
              ? appendix.appendixNganluongConvert.deviceInfos.reduce((arr, current) => {
                  arr.push(current.name)

                  return arr
                }, [])
              : []

          if (map.length > 0) {
            if (map.includes('ONBOARD_QR') && map.length == 1) {
              return false
            }

            if (map.includes('ONBOARD_QR') && map.length > 1) {
              let flag = false
              map.map(item => {
                if (item != 'ONBOARD_QR') {
                  flag = true
                }
              })

              return flag
            }
          }
        }

        if (!appendix) {
          return false
        }

        return true
      },
      isCashback(arr) {
        return arr.find(s => s.appendixDevice.isCashback === true && s.isCreatedWithContract)
      },
      isLend(arr) {
        return arr.find(s => s.appendixDevice.isLend === true && s.isCreatedWithContract)
      },
      isRent(arr) {
        return arr.find(s => s.appendixDevice.isRent === true && s.isCreatedWithContract)
      },
      getConfigSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              const config = data.data
              this.tableContactInfos = config.tableContactInfos
            }
          })
          .catch(error => console.log(error))
      },
      getConfigInfoChange() {
        return CommonService.getConfigInfoChange()
          .then(data => {
            if (data.success) {
              this.configInfoChange = data.data
            }
          })
          .catch(error => console.log(error))
      },
      isDeviceExsistQrNl(arr) {
        let flag = false

        const appendix = arr.find(
          s =>
            s.appendixNganluongConvert.isCashback !== true &&
            s.appendixNganluongConvert.isLend !== true &&
            s.isCreatedWithContract
        )

        if (appendix) {
          const deviceInfo =
            appendix.appendixNganluongConvert && appendix.appendixNganluongConvert.deviceInfos
              ? appendix.appendixNganluongConvert.deviceInfos.find(
                  item => item.name == 'ONBOARD_QR'
                )
              : {}
          if (deviceInfo && Object.keys(deviceInfo).length > 0) {
            flag = true
          }
        }

        return flag
      },
      isDeviceExsistQr(arr) {
        let flag = false

        const appendix = arr.find(
          s =>
            s.appendixDevice.isCashback !== true &&
            s.appendixDevice.isLend !== true &&
            s.isCreatedWithContract
        )

        if (appendix) {
          const deviceInfo =
            appendix.appendixDevice && appendix.appendixDevice.deviceInfos
              ? appendix.appendixDevice.deviceInfos.find(item => item.name == 'ONBOARD_QR')
              : {}
          if (deviceInfo && Object.keys(deviceInfo).length > 0) {
            flag = true
          }
        }

        return flag
      },
      isTapToPhone(arr) {
        let flag = false

        const appendix = arr.find(
          s =>
            s.appendixDevice.isCashback !== true &&
            s.appendixDevice.isLend !== true &&
            s.isCreatedWithContract
        )

        if (appendix) {
          const deviceInfo =
            appendix.appendixDevice && appendix.appendixDevice.deviceInfos
              ? appendix.appendixDevice.deviceInfos.find(item => item.name == 'TAP_2_PHONE')
              : {}
          if (deviceInfo && Object.keys(deviceInfo).length > 0) {
            flag = true
          }
        }

        return flag
      },
      isOnboardQr(arr) {
        const appendix = arr.find(
          s =>
            s.appendixDevice &&
            s.appendixDevice.isCashback !== true &&
            s.appendixDevice.isLend !== true &&
            s.appendixDevice.isRent !== true &&
            s.isCreatedWithContract
        )
        if (!appendix) return false

        const deviceInfos =
          appendix.appendixDevice && appendix.appendixDevice.deviceInfos
            ? appendix.appendixDevice.deviceInfos
            : []

        return deviceInfos.some(item => item.name === 'ONBOARD_QR')
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
